import {Box,Typography} from "@mui/material";

const Footer = () => {
  return ( 
    <div>
      <Box sx={{ px: 2.5, py: 1, mt: 5, textAlign: "center" }}>
        <Typography sx={{ color: "#AAAAAA", fontSize: "14px" }} variant="span">
          ©{new Date().getFullYear()}&nbsp; Sivoo, Inc. SivooTV and SivooTV+ are registered trademarks. All content officially licensed. Package channels may change without notice. Sivoo, Inc. 1900 JFK Blvd. Ste 1323, Philadelphia, PA 19103.
        </Typography>
      </Box>
    </div>
    
  );
};

export default Footer;